module.exports = __webpack_public_path__ + "media/images/svg/pinterest-de267c22f33dd0e46d516f1390fb0b61.svg";